import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { authApi } from "../../api/authApi";
import "./EmailUnsubscribe.css";

const EmailUnsubscribe = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("ready");
  const [error, setError] = useState("");
  const userId = searchParams.get("userId") || "";
  const token = searchParams.get("token") || "";

  const unsubscribe = async () => {
    setStatus("submitting");
    setError("");
    try {
      await authApi.unsubscribeFromOptionalEmails(userId, token);
      setStatus("complete");
    } catch (unsubscribeError) {
      setError(
        unsubscribeError.response?.data?.error ||
          "We could not verify this unsubscribe link. Sign in to update your email preferences.",
      );
      setStatus("error");
    }
  };

  return (
    <>
      <Helmet>
        <title>Email preferences | Toora Flex</title>
        <meta name="robots" content="noindex,nofollow" />
        <meta name="referrer" content="no-referrer" />
      </Helmet>
      <main className="email-unsubscribe-page">
      <section className="email-unsubscribe-card">
        {status === "complete" ? (
          <>
            <div className="email-unsubscribe-icon is-done" aria-hidden="true">
              ✓
            </div>
            <h1>You&apos;re unsubscribed</h1>
            <p>
              You will no longer receive optional newsletters, promotions, or
              non-essential product updates from Toora Flex.
            </p>
          </>
        ) : (
          <>
            <div className="email-unsubscribe-icon" aria-hidden="true">
              @
            </div>
            <h1>Manage optional email updates</h1>
            <p>
              Confirm below to stop optional newsletters, promotions, and
              non-essential product updates.
            </p>
            {error && (
              <div className="email-unsubscribe-error" role="alert">
                {error}
              </div>
            )}
            {(!userId.trim() || !token.trim()) && !error && (
              <div className="email-unsubscribe-error" role="alert">
                This link is incomplete. Sign in to manage your email
                preferences.
              </div>
            )}
            <button
              type="button"
              className="email-unsubscribe-button"
              onClick={unsubscribe}
              disabled={
                status === "submitting" || !userId.trim() || !token.trim()
              }
            >
              {status === "submitting"
                ? "Updating preferences..."
                : "Unsubscribe from optional updates"}
            </button>
          </>
        )}
        <p className="email-unsubscribe-essential">
          Essential account, security, payment, onboarding, maintenance, and
          service notices may still be sent while your account or service
          remains active.
        </p>
        <p className="email-unsubscribe-links">
          <Link to="/privacy">Privacy Policy</Link>
          {" · "}
          <Link to="/login">Account settings</Link>
        </p>
      </section>
      </main>
    </>
  );
};

export default EmailUnsubscribe;
